<template>
  <div class="aside" v-if="!hasAside">
    <div class="aside__title">{{ parentTitle }}</div>
    <el-scrollbar class="scrollbar" style="height: 100%">
      <el-menu :default-active="currentPath" router>
        <template v-for="item in aside">
          <div :key="item.path" v-if="!item.meta.hidden">
            <el-submenu
              v-if="item.children"
              :key="item.path"
              :index="item.path"
            >
              <template slot="title">
                <i :class="menuIcon(item)"></i>
                <span>{{ item.meta.title }}</span>
              </template>
              <template v-for="children in item.children">
                <el-menu-item
                  v-if="!children.meta.hidden"
                  :key="children.path"
                  :index="children.path"
                >
                  <template slot="title">
                    <span>{{ children.meta.title }}</span>
                  </template>
                </el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item v-else :key="'_' + item.path" :index="item.path">
              <template slot="title">
                <i :class="menuIcon(item)"></i>
                <span>{{ item.meta.title }}</span>
              </template>
            </el-menu-item>
          </div>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { asyncRoutes } from "@/router";
import { mapGetters } from "vuex";
import { filterRoutesByPermission } from "@/utils/permission";

export default {
  computed: {
    ...mapGetters(["permission"]),
    currentPath() {
      return this.$route.meta?.prevPath || this.$route.path;
    },
    aside() {
      const { meta } = this.$route;
      const routes = filterRoutesByPermission(asyncRoutes, this.permission);
      const item = routes.find((item) => item.path === meta?.parentPath);
      return item?.children;
    },
    parentTitle() {
      const { meta } = this.$route;
      const routes = filterRoutesByPermission(asyncRoutes, this.permission);
      const item = routes.find((item) => item.path === meta?.parentPath);
      return item?.meta?.title || meta?.title || "";
    },
    hasAside() {
      return this.aside?.every((item) => item.meta?.hidden);
    },
  },
  methods: {
    menuIcon(item) {
      const title = item?.meta?.title || "";
      const iconMap = {
        工作台: "el-icon-s-home",
        数据看板: "el-icon-data-board",
        站点数据: "el-icon-s-data",
        站点绑定: "el-icon-connection",
        授权账号: "el-icon-user",
        "Google 设置": "el-icon-setting",
        同步日志: "el-icon-refresh-left",
        站点列表: "el-icon-monitor",
        商机列表: "el-icon-message",
        商机数据: "el-icon-data-line",
        系统设置: "el-icon-setting",
        邮箱设置: "el-icon-message",
        操作日志: "el-icon-document",
        管理员: "el-icon-user-solid",
        管理员列表: "el-icon-user-solid",
        子账户管理: "el-icon-user",
        关键词管理: "el-icon-search",
        效果月报: "el-icon-data-analysis",
      };
      return iconMap[title] || "el-icon-menu";
    },
  },
};
</script>

<style lang="scss">
.aside {
  width: 210px;
  height: 100%;
  overflow: hidden;
  background: #ffffff;
  border-right: 1px solid #e8edf4;

  &__title {
    height: 58px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    color: #111827;
    font-size: 18px;
    font-weight: 700;
    box-sizing: border-box;
  }

  .el-scrollbar {
    height: calc(100% - 58px);

    .el-menu {
      width: 210px;
      border-right: none;
      background: transparent;
      padding: 6px 6px 14px;
      box-sizing: border-box;

      :deep(.el-submenu__title),
      .el-menu-item {
        position: relative;
        color: #374151;
        font-size: 15px;
        font-weight: 500;
        height: 46px;
        line-height: 46px;
        padding: 0 18px !important;
        box-sizing: border-box;
        min-width: auto;
        margin: 4px 0;
        border-radius: 8px;
        background: transparent;

        &:hover,
        &:focus {
          color: #1476ff;
          background: #f4f8ff;
        }

        i {
          width: 18px;
          margin-right: 12px;
          color: #4b5563;
          font-size: 17px;
          text-align: center;
        }

        &.is-active {
          color: #1476ff;
          background: #eaf3ff;
          font-weight: 700;

          &::before {
            content: "";
            position: absolute;
            left: -6px;
            top: 10px;
            width: 3px;
            height: 26px;
            border-radius: 0 4px 4px 0;
            background: #1476ff;
          }

          i {
            color: #1476ff;
          }
        }
      }

      .el-submenu {
        .el-menu-item {
          padding-left: 48px !important;
          font-size: 14px;
        }

        &.is-active {
          // background-color: #000;
        }
      }

      .iconfont {
        margin-right: 10px;
        margin-left: 10px;
      }

      :deep(.el-submenu__icon-arrow) {
        margin-top: -4px;
      }
    }
  }
}
</style>
